var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"disabled":_vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},[(!_vm.loading)?_vm._t("default"):_c('i',{staticClass:"fa fa-spinner fa-spin"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }